/**
 * Actions asynchrones billing — chargent wallet/packs/plan dans Redux.
 * Pas de createAsyncThunk pour rester cohérent avec le reste du repo
 * (les autres slices font tout par actions synchrones + appel d'API
 * dans le composant). On expose ici des thunks « manuels ».
 */
import {
  setBillingLoading,
  setBillingError,
  setWallet,
  setPacks,
  setSubscription,
  openInsufficient,
} from '../../reduxLib/slices/billingSlice'
import {
  createPackCheckout,
  estimateCost,
  fetchPacks,
  fetchUserPlan,
  fetchWallet,
} from './billingAPI'

export const loadWallet = () => async (dispatch) => {
  dispatch(setBillingLoading(true))
  const response = await fetchWallet()
  if (response && response.status === 200) {
    dispatch(setWallet(response.data))
  } else {
    dispatch(
      setBillingError(
        response?.data?.detail || 'Impossible de charger les crédits.',
      ),
    )
  }
}

export const loadPacks = () => async (dispatch) => {
  const response = await fetchPacks()
  if (response && response.status === 200) {
    dispatch(setPacks(response.data))
  }
}

export const loadSubscription = () => async (dispatch) => {
  const response = await fetchUserPlan()
  if (response && response.status === 200) {
    dispatch(setSubscription(response.data))
  }
}

export const startPackCheckout = (packCode) => async () => {
  const response = await createPackCheckout(packCode)
  if (response && response.status === 200 && response.data?.checkout_url) {
    // Redirection vers Stripe — on quitte l'app le temps du paiement.
    window.location.href = response.data.checkout_url
    return true
  }
  return false
}

export const getEstimate = (params) => async (dispatch) => {
  const response = await estimateCost(params)
  if (response && response.status === 200) {
    return response.data
  }
  if (response && response.status === 402) {
    dispatch(openInsufficient(response.data))
  }
  return null
}

// Helper appelé par l'intercepteur axios global quand un endpoint IA renvoie
// HTTP 402. Le payload de l'erreur est dispatché tel quel dans Redux pour que
// la modale `InsufficientCreditsModal` s'ouvre.
export const handleHttp402 = (errorPayload) => (dispatch) => {
  dispatch(openInsufficient(errorPayload || { code: 'insufficient_credits' }))
}
